const constactDomain: string = process.env.VUE_APP_CONTACT_URL as string;
const constactDomainIndividual: string = process.env.VUE_APP_CONTACT_INDIVIDUAL_URL as string;
const constactDomainCompany: string = process.env.VUE_APP_CONTACT_COMPANY_URL as string;

const ContactRepository = {
  sendContact: async (payload: any) => {
    return fetch(constactDomain, {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(payload),
    }).then((response: any) => response.json())
  },
  sendContactIndividual: async (payload: any) => {
    return fetch(constactDomainIndividual, {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(payload),
    }).then((response: any) => response.json())
  },
  sendContactCompany: async (payload: any) => {
    return fetch(constactDomainCompany, {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(payload),
    }).then((response: any) => response.json())
  }
};

export default ContactRepository;